/* eslint-disable no-shadow */
import React from 'react';
import { Button, Dropdown, Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { ActionWrapper } from '../../inventory.styled';

const OptionsSelectionModal = ({
  disableOptionSelection,
  disableQuantityInput,
  handleOptionsChange,
  decrementQuantity,
  incrementQuantity,
  disableIncrement,
  disableDecrement,
  handleQuantity,
  getOptionValue,
  errorMessage,
  quantity,
  onClose,
  options,
  isOpen,
}) => {
  return (
    <Modal size="small" open={isOpen}>
      <Modal.Header>Select options</Modal.Header>
      <Modal.Content>
        <div style={{ color: 'red', marginBottom: '5px' }}>{errorMessage}</div>

        <ActionWrapper>
          {options.map(({ label, options }) => (
            <div key={label} className="dropdown">
              <span className="label">{label}</span>

              <Dropdown
                onChange={(e, { value }) => handleOptionsChange(label, value)}
                disabled={disableOptionSelection}
                value={getOptionValue(label)}
                className="drop-down"
                placeholder={label}
                options={options}
                clearable
                selection
              />
            </div>
          ))}

          <div className="flex_col">
            <span className="label">Quantity</span>

            <div className="btn-left">
              <button disabled={disableDecrement} onClick={decrementQuantity} className="less" type="button">
                -
              </button>

              <input disabled={disableQuantityInput} onChange={handleQuantity} value={quantity} type="number" min={0} />

              <button disabled={disableIncrement} onClick={incrementQuantity} className="add" type="button">
                +
              </button>
            </div>
          </div>
        </ActionWrapper>
      </Modal.Content>

      <Modal.Actions>
        <Button color="blue" onClick={onClose}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

OptionsSelectionModal.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  disableOptionSelection: PropTypes.bool.isRequired,
  disableQuantityInput: PropTypes.bool.isRequired,
  handleOptionsChange: PropTypes.func.isRequired,
  incrementQuantity: PropTypes.func.isRequired,
  decrementQuantity: PropTypes.func.isRequired,
  disableIncrement: PropTypes.bool.isRequired,
  disableDecrement: PropTypes.bool.isRequired,
  handleQuantity: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default OptionsSelectionModal;
